import { useRef, useState } from "react";
import { Upload, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";

const isRatecon = (f) => f && (f.type === "application/pdf" || f.type.startsWith("image/") || /\.pdf$/i.test(f.name));

export const RateconDropzone = ({ file, busy, onFile }) => {
  const ref = useRef(null);
  const [over, setOver] = useState(false);
  const pick = (f) => {
    if (!f) return;
    if (!isRatecon(f)) { toast.error("Please use a PDF or an image file"); return; }
    onFile(f);
  };
  const onDrop = (e) => { e.preventDefault(); setOver(false); if (!busy) pick(e.dataTransfer.files?.[0]); };
  const onDragOver = (e) => { e.preventDefault(); if (!busy) setOver(true); };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => !busy && ref.current?.click()}
      onKeyDown={(e) => { if (e.key === "Enter" && !busy) ref.current?.click(); }}
      onDragEnter={onDragOver}
      onDragOver={onDragOver}
      onDragLeave={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) setOver(false); }}
      onDrop={onDrop}
      className={`mt-2 border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-colors ${over ? "border-[#002FA7] bg-blue-50 ring-4 ring-blue-100" : "border-slate-300 hover:border-[#002FA7]"}`}
      data-testid="ratecon-dropzone"
      data-dragging={over ? "true" : "false"}
    >
      <input ref={ref} type="file" className="hidden" accept="application/pdf,image/*" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; pick(f); }} data-testid="ratecon-file-input" />
      {over ? (
        <div className="text-[#002FA7]" data-testid="ratecon-dropzone-over">
          <Upload className="w-8 h-8 mx-auto" />
          <p className="mt-2 text-sm font-semibold">Drop the ratecon here</p>
          <p className="text-xs">AI will read it and fill in the details</p>
        </div>
      ) : file ? (
        <div className="flex items-center justify-center gap-2 text-sm text-slate-700" data-testid="ratecon-file-name">
          {busy ? <Loader2 className="w-4 h-4 animate-spin text-[#002FA7]" /> : <FileText className="w-4 h-4 text-[#002FA7]" />}
          <span className="font-medium truncate max-w-[60%]">{file.name}</span>
          <span className="text-slate-400">({(file.size / 1024).toFixed(0)} KB)</span>
          {!busy && <span className="text-xs text-slate-500">· click or drop to replace</span>}
        </div>
      ) : (
        <>
          <Upload className="w-8 h-8 mx-auto text-slate-400" />
          <p className="mt-2 text-sm font-medium text-slate-700">Drag & drop the ratecon here, or click to browse</p>
          <p className="text-xs text-slate-500">PDF or image — AI fills in the details for you to check</p>
        </>
      )}
    </div>
  );
};
